import { render, staticRenderFns } from "./CityManage.vue?vue&type=template&id=025c5241&scoped=true&"
import script from "./CityManage.vue?vue&type=script&lang=js&"
export * from "./CityManage.vue?vue&type=script&lang=js&"
import style0 from "./CityManage.vue?vue&type=style&index=0&id=025c5241&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025c5241",
  null
  
)

export default component.exports